const $inject = ['$scope', '$routeParams', '$filter', 'countriesService', 'dataService'];

const lbaCountrySelectCtrl = function ($scope, $routeParams, $filter, countriesService, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  vm.selectType = vm.settings.selectType || 'multi';
  vm.refreshCountries = refreshCountries;
  vm.copyItems = copyItems;

  if(vm.selectType === 'multi' && !vm.data) {
    vm.data = [];
  }

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function refreshCountries(userSearch) {
    const countries = countriesService.get();
    vm.countries = $filter('filter')(countries, userSearch, false);
  }
  
  function copyItems() {
    copyTextToClipboard(vm.data.join(', '));
  }

  function copyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
  
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = 0;
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;
  
    document.body.appendChild(textArea);
  
    textArea.select();
  
    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
    } catch (err) {
      console.log('Oops, unable to copy');
    }
  
    document.body.removeChild(textArea);
  }

  vm.taggingFunc = function (event) {
    event.preventDefault();
    let re = /\r?\n|\r/g;
    
    let pasted = event.clipboardData.getData('text/plain').replace(re, '').split(',');
    let pastedCleaned = _.uniq(pasted).map(Function.prototype.call, String.prototype.trim);

    vm.data = _.union(vm.data, pastedCleaned);
  };
};

lbaCountrySelectCtrl.$inject = $inject;

export default lbaCountrySelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaCountrySelect/lbaCountrySelectCtrl.js